import { mapValues } from 'lodash';
import { arrayOf, Schema } from 'normalizr';
import { transformUtil } from 'js-utils/transformation';

export const organizationSchema = new Schema('organizations');

export const transformOrganizations = (organizations = undefined) => {
    if (!organizations) {
        return {};
    }

    const { entities, result: organizationIds } = transformUtil({
        response: organizations,
        schema: arrayOf(organizationSchema),
    });

    // set empty default roles and members
    const organizationEntities = mapValues(
        entities.organizations,
        (organization) => ({
            memberIds: null,
            roleIds: null,
            invitationIds: null,
            ...organization,
        }),
    );

    return {
        organizationEntities,
        organizationIds,
    };
};
